<template>
  <div class="benefit-btn-wrap">
    <van-button
      v-for="(btn, index) in renderBtns"
      @click="btn.handler"
      :key="index"
      block
      type="default"
      v-bind="btn.params"
      :disabled="btn.disabled"
      round
      >{{ btn.text }}</van-button
    >
  </div>
</template>

<script>
import throttle from "lodash.throttle";
import { mapActions, mapState } from "vuex";
import { jsonSafeParse, replaceDay } from "@/utils";
import { queryH5JumpUrl } from "@/apis/product";
import copy from "copy-to-clipboard";

export default {
  props: {
    benefit_type: String,
    benefitInfo: Object,
    selectSku: Object,
    account: String,
    phone_account: String,
    showAccount: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "namespace",
      "userInfo",
      "source",
      "namespaceInfo",
      "isMiniProgram",
      "benefit_source",
    ]),
    renderBtns() {
      return [
        {
          condition: true,
          event_id: "benefit_detail_click_button1",
          disabled: this.btnDisabled,
          handler: this.submit,
          text: this.getBtnText,
          params: {
            class: "benefit-btn",
          },
        },
      ].filter((item) => item.condition);
    },
    // 账号充值类型为手机号的sku，自动填入权益手机号

    isFreeBenefit() {
      return this.selectSku.item_price === 0;
    },
    // 判断商品下架
    productOff() {
      return this.selectSku.status === 0;
    },
    btnDisabled() {
      return this.productOff;
    },

    // 按钮文案逻辑
    getBtnText() {
      const temp = jsonSafeParse(this.$getConfigValue("BENEFIT_SPECIAL_TEXT"));
      for (let k in temp) {
        if (this.benefitInfo.type?.startsWith(k) && temp[k]) {
          return temp[k];
        }
      }
      if (this.productOff) {
        return "无货，请选择其他面额";
      }

      if (this.selectSku.item_price > 0) {
        return `立即购买（${this.selectSku.item_price}元）`;
      }
      return "立即领取";
    },
  },

  methods: {
    ...mapActions(["fetchUserInfo"]),
    submit: throttle(
      async function () {
        document.body.scrollIntoView();
        const MALICIOUS_USERS = this.$getConfigValue("MALICIOUS_USERS") + "";
        if (MALICIOUS_USERS) {
          const users = MALICIOUS_USERS.split(",").filter(Boolean);
          if (users.includes(this.userInfo.id + "")) {
            this.$alert({
              title: "温馨提示",
              message: this.$getConfigValue("MALICIOUS_USER_ALERT_TEXT"),
            });
            return;
          }
        }
        const hotelType = jsonSafeParse(
          this.$getConfigValue("HOTEL_BENEFIT_TYPE"),
          []
        );
        if (hotelType.includes(this.benefitInfo.type)) {
          this.$router.push(
            `/hotel/list?benefitType=${this.benefitInfo.type}&product_code=${this.selectSku.product_code}`
          );
          return;
        }
        if (this.benefitInfo.type === "buffet") {
          this.$router.push(
            `/buffet/list/?benefitType=${this.benefitInfo.type}`
          );
          return;
        }
        // 判断是否为团油或者易加油
        // 对加油链接进行处理
        // if (this.benefitInfo.type === "yioil") {
        //   this.checkYioil();
        //   return;
        // }
        // 校验点数
        if (this.showAccount && !this.account) {
          this.$toast("请输入充值账号");
          return;
        }

        // 校验输入的账号格式
        const rechargeConfig =
          this.selectSku.allowed_recharge_account_types.find(
            (item) =>
              item.account_type_number ===
              this.selectSku.recharge_account_number
          ) || {};
        if (rechargeConfig?.account_regex_rule) {
          if (
            !new RegExp(rechargeConfig?.account_regex_rule).test(this.account)
          ) {
            this.$toast(
              `您输入的${rechargeConfig.account_type_name}格式不正确，请核实后重新输入`
            );
            return;
          }
        }
        if (this.selectSku.need_real_name) {
          this.$toast("该权益需要实名认证");
        }

        // 跳转到h5
        if (this.selectSku.top_up_type === 5) {
          let url =
            this.selectSku.activation_page ||
            this.selectSku.partner_jump_url ||
            "";

          if (!url) {
            const { data } = await queryH5JumpUrl({
              user_id: this.userInfo.id,
              generate_h5_code: this.selectSku.generate_h5,
              spu_id: this.selectSku.generate_h5_spu_id,
              phone_number: this.userInfo.user_phone,
            });
            url = data;
          }
          if (url.startsWith("/")) {
            this.$router.push(url);
          } else {
            if (this.isMiniProgram) {
              this.$confirm({
                title: "温馨提示",
                message: `请复制链接前往浏览器使用`,
                confirmButtonText: "复制链接",
              }).then(() => {
                copy(url);
                this.$toast("复制成功");
              });
            } else {
              location.href = url;
            }
          }
          return;
        }

        if (this.selectSku.recharge_account_number === 6) {
          await this.$alert({
            title: "温馨提示",
            message: `确定充值到平台账号：<b>${this.phone_account}</b>吗？`,
            cancelButtonText: "我再想想",
            confirmButtonText: "确认号码",
          });
        }
        // 手机号充值增加额外提醒
        // 如果用户首次使用手机号充值，怎弹窗提醒用户，并且异步校验手机号是否能够充值
        if (
          this.showAccount &&
          this.namespaceInfo.enable_recharge_account_limit
        ) {
          if (this.selectSku.recharge_account_number !== 6) {
            await this.$alert({
              title: "温馨提示",
              confirmButtonText: "确认号码",
              message: `<div>确定充值到${rechargeConfig.account_type_name}：<b>${this.phone_account}</b>吗？<br />此${rechargeConfig.account_type_name}将会用于所有${rechargeConfig.account_type_name}充值的权益，填写后不可修改，请确认是否继续使用？</div>`,
            });
          }
        }
        // 兑换码有激活提示
        const { activation_tips } = this.selectSku;
        if (
          this.selectSku.top_up_type === 3 ||
          this.selectSku.top_up_type === 4
        ) {
          await this.$alert({
            title: "温馨提示",
            message: replaceDay(
              activation_tips,
              this.benefitInfo.coupon_days === -1
                ? "会员有效期"
                : this.benefitInfo.coupon_days
            ),
            confirmButtonText: this.isFreeBenefit ? "继续领取" : "继续购买",
          });
        }
      },
      1500,
      { trailing: false }
    ),
    async toPay() {
      // top_up_type:
      // (1, "直冲-购买"),
      // (2, "直冲-免费领取"),
      // (3, "兑换码-购买"),
      // (4, "兑换码-免费领取"),
      // (5, "跳转H5")

      // 免费领取逻辑
      if (this.isFreeBenefit) {
        // 直冲虚拟权益激活提示
        if (this.account) {
          this.$alert({
            title: "温馨提示",
            message: `<div style="white-space:initial">
            <p style="font-size:16px">${this.selectSku.item_name},<br/>即将充值到您的账户，请确认</p>
            <p style="color:#999;padding-top:10px">虚拟商品，充值之后概不退换</p></div>`,
            confirmButtonText: "继续领取",
          }).then(() => {
            this.$toast("激活权益");
          });
        } else {
          this.$toast("激活权益");
        }
        return;
      }
      this.$toast("跳转去支付");
    },
  },
};
</script>